// Libraries
import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";

// Functions
import { registerLocale, setDefaultLocale } from "react-datepicker";

// Constants
import de from "date-fns/locale/de";
registerLocale("de", de);
setDefaultLocale("de");

const DateInput = ({ handleDateSelect, selectedDate, showingDate }) => {
  const [startDate, setStartDate] = useState(null);

  // Show Date as an Input
  const DateInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <div className="form-group">
      <label htmlFor={"date"}>Date</label>
      <input
        id={"date"}
        name={"date"}
        value={value ? value : selectedDate}
        className="form-control rounded"
        onClick={onClick}
        onChange={onChange}
        ref={ref}
        autoComplete="false"
        // placeholder={selectedDate}
      />
    </div>
  ));

  // DatePicker Component
  return (
    <DatePicker
      selected={startDate}
      openToDate={startDate ? new Date(startDate) : new Date(showingDate)}
      onChange={(date) => setStartDate(date)}
      onSelect={handleDateSelect}
      locale="de"
      dateFormat="dd.MM.yyyy"
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      customInput={<DateInput />}
      // peekNextMonth
    />
  );
};

export default DateInput;
